import { useState } from 'react';

export default function ConstructionTab() {
  const [showAddModal, setShowAddModal] = useState(false);

  const constructionData = [
    { id: 1, name: '東京本社ビル改修工事', location: '東京都千代田区', progress: 75, status: '進行中', startDate: '2025-01-01', models: 24, size: '1.2 GB' },
    { id: 2, name: '大阪支店新築プロジェクト', location: '大阪府大阪市', progress: 45, status: '進行中', startDate: '2024-12-15', models: 18, size: '890 MB' },
    { id: 3, name: '名古屋店舗リノベーション', location: '愛知県名古屋市', progress: 90, status: '進行中', startDate: '2024-11-20', models: 32, size: '1.5 GB' },
    { id: 4, name: '福岡オフィス内装工事', location: '福岡県福岡市', progress: 100, status: '完了', startDate: '2024-10-01', models: 15, size: '650 MB' },
    { id: 5, name: '札幌商業施設建設', location: '北海道札幌市', progress: 30, status: '進行中', startDate: '2025-01-10', models: 12, size: '720 MB' },
    { id: 6, name: '横浜マンション改修', location: '神奈川県横浜市', progress: 60, status: '進行中', startDate: '2024-12-01', models: 28, size: '1.1 GB' },
  ];

  return (
    <div className="p-8">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">施工データ管理</h2>
          <p className="text-gray-600">施工現場のXRデータとプロジェクト情報</p>
        </div>
        <button
          onClick={() => setShowAddModal(true)}
          className="px-6 py-3 bg-teal-500 text-white rounded-lg font-medium hover:bg-teal-600 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-add-line text-lg"></i>
          新規プロジェクト
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <div className="bg-white rounded-xl p-6 border border-gray-200/80">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center">
              <i className="ri-tools-fill text-2xl text-white"></i>
            </div>
            <span className="text-sm font-semibold text-green-600">+8%</span>
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-1">432</h3>
          <p className="text-sm text-gray-600">総施工データ数</p>
        </div>

        <div className="bg-white rounded-xl p-6 border border-gray-200/80">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center">
              <i className="ri-time-line text-2xl text-white"></i>
            </div>
            <span className="text-sm font-semibold text-blue-600">進行中</span>
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-1">5</h3>
          <p className="text-sm text-gray-600">アクティブプロジェクト</p>
        </div>

        <div className="bg-white rounded-xl p-6 border border-gray-200/80">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-2xl text-white"></i>
            </div>
            <span className="text-sm font-semibold text-green-600">完了</span>
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-1">1</h3>
          <p className="text-sm text-gray-600">完了プロジェクト</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-200/80">
        <div className="p-6 border-b border-gray-200/80">
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
            <input
              type="text"
              placeholder="プロジェクトを検索..."
              className="w-full pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="p-6 space-y-4">
          {constructionData.map((project) => (
            <div key={project.id} className="border border-gray-200/80 rounded-xl p-6 hover:shadow-md transition-shadow">
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{project.name}</h3>
                  <div className="flex items-center gap-4 text-sm text-gray-600">
                    <span className="flex items-center gap-1">
                      <i className="ri-map-pin-line"></i>
                      {project.location}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {project.startDate}
                    </span>
                  </div>
                </div>
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                  project.status === '完了' 
                    ? 'bg-green-100 text-green-700' 
                    : 'bg-blue-100 text-blue-700'
                }`}>
                  {project.status}
                </span>
              </div>

              <div className="mb-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium text-gray-700">進捗状況</span>
                  <span className="text-sm font-bold text-gray-900">{project.progress}%</span>
                </div>
                <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-gradient-to-r from-orange-500 to-orange-600 rounded-full transition-all"
                    style={{ width: `${project.progress}%` }}
                  ></div>
                </div>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-gray-200/80">
                <div className="flex items-center gap-6 text-sm text-gray-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-cube-line"></i>
                    {project.models}モデル
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-database-2-line"></i>
                    {project.size}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <button className="px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                    詳細
                  </button>
                  <button className="px-4 py-2 bg-teal-500 text-white rounded-lg text-sm font-medium hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap">
                    編集
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showAddModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-2xl w-full p-8">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-gray-900">新規プロジェクト作成</h3>
              <button
                onClick={() => setShowAddModal(false)}
                className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-gray-600"></i>
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">プロジェクト名</label>
                <input
                  type="text"
                  placeholder="例: 東京本社ビル改修工事"
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">施工場所</label>
                <input
                  type="text"
                  placeholder="例: 東京都千代田区"
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">開始日</label>
                <input
                  type="date"
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">説明</label>
                <textarea
                  rows={4}
                  placeholder="プロジェクトの詳細を入力..."
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm resize-none"
                ></textarea>
              </div>

              <div className="flex items-center gap-3 pt-4">
                <button
                  onClick={() => setShowAddModal(false)}
                  className="flex-1 px-6 py-3 border border-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  キャンセル
                </button>
                <button className="flex-1 px-6 py-3 bg-teal-500 text-white rounded-lg font-medium hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap">
                  作成
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
